import $ from "jquery";

jQuery(function ($) {
  const $tabs = $(".shareholder-tab-link");
  const $wrapper = $("#shareholder-docs-wrapper");

  if (!$tabs.length || !$wrapper.length) {
    return;
  }

  $tabs.on("click", function (e) {
    e.preventDefault();
    const $clickedTab = $(this);

    if ($clickedTab.hasClass("active")) {
      return;
    }

    // Toggle active classes
    $tabs.removeClass("active");
    $clickedTab.addClass("active");

    const index = $clickedTab.data("index");
    const postId = $clickedTab.data("post-id");
    const ajaxUrl = window.hdConfig?._ajaxUrl || "/wp-admin/admin-ajax.php";

    // Set loading state
    $wrapper.addClass("is-loading").css("opacity", 0.6);

    $.ajax({
      url: ajaxUrl,
      type: "POST",
      dataType: "json",
      data: {
        action: "ajax_shareholders_docs",
        post_id: postId,
        index: index
      },
      success: function (response) {
        $wrapper.removeClass("is-loading").css("opacity", 1);
        if (response.success && response.data && response.data.html) {
          $wrapper.html(response.data.html);
        } else {
          $wrapper.html('<div class="shareholders-docs-empty"><p>Không tải được tài liệu. Vui lòng thử lại.</p></div>');
        }
      },
      error: function () {
        $wrapper.removeClass("is-loading").css("opacity", 1);
        $wrapper.html('<div class="shareholders-docs-empty"><p>Không tải được tài liệu. Vui lòng thử lại.</p></div>');
      }
    });
  });
});
